module.exports = "/8/0-con-tr/index.html.a46c66f365403503c34cafdc9863cfa3.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30541.md
 ** module id = 566
 ** module chunks = 0
 **/